import React, { useEffect, useState } from "react";
import "./DisplayNumbers.css";

const DisplayNumbers = ({ number }) => {
  const [prevNumber, setPrevNumber] = useState(number);
  const [digits, setDigits] = useState(String(number).split(""));
  
  useEffect(() => {
    setDigits(String(number).padStart(String(prevNumber).length, "").split(""));
    setPrevNumber(number);
  }, [number]);

  return (
    <div className="rolling-number">
      {digits.map((digit, index) => (
        <div className="digit-container" key={index}>
          <div
            className="digit-strip"
            style={{ transform: `translateY(-${digit * 10}%)` }}
          >
            {[...Array(10).keys()].map((d) => (
              <div className="digit" key={d}>
                {d}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DisplayNumbers;